import serviceicn1 from "../Assets/Icons/service-icn1.png";
import serviceicn2 from "../Assets/Icons/service-icn2.png";
import serviceicn3 from "../Assets/Icons/service-icn3.png";
import ChevronDown from "../Assets/Icons/ChevronDown";

const IconHelper = {
  serviceicn1,
  serviceicn2,
  serviceicn3,
  ChevronDown,
};

export default IconHelper;
